export default "__VITE_PUBLIC_ASSET__b318b039__"